import React, { useEffect, useState } from "react";
import StyledContentCard from "../../components/styledComponent/styledContentCard";
import { Tag } from "antd";
import CustomTable from "../../components/styledComponent/styledTable";
import { listAllQuotation } from "../../server/quotationServices";
import { Capitalize } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../contexts/appContext";
import { MdVerified } from "react-icons/md";
import { PRIMARY_THEME } from "../../constants/constant";

function QuotationPage() {
  const navigate = useNavigate();

  const { startLoading, stopLoading } = useAppContext();
  const [tableData, setTableData] = useState([]);

  const fetchQuotationList = async () => {
    try {
      startLoading();
      const quotation = await listAllQuotation();
      setTableData(quotation.data);
    } catch (error) {
      console.error("Error fetching quotation:", error);
    } finally {
      stopLoading();
    }
  };
  useEffect(() => {
    fetchQuotationList();
  }, []);
  return (
    <div>
      <StyledContentCard title={"Quotation"}>
        <CustomTable
          data={tableData}
          columns={quotationColumn}
          rowKey="id"
          onRow={(record) => {
            return {
              onClick: () => {
                navigate(`/quotation/${record.quotation.id}`);
              },
              className: "clickable",
            };
          }}
        />
      </StyledContentCard>
    </div>
  );
}
export const quotationColumn = [
  {
    title: "Id",
    dataIndex: ["quotation", "id"],
    key: "id",
  },
  {
    title: "Customer Name",
    dataIndex: ["customer", "name"],
    key: "customer_name",
    render: (_, value) => (
      <div className="flex items-center gap-2">
        {value.customer.name}
        {value.customer.is_vip && (
          <MdVerified size={18} color={PRIMARY_THEME} />
        )}
      </div>
    ),
  },
  {
    title: "Staff Name",
    dataIndex: ["staff", "name"],
    key: "staff_name",
  },
  {
    title: "Grand Total",
    dataIndex: ["quotation", "grand_total"],
    key: "grand_total",
  },
  {
    title: "Status",
    dataIndex: ["quotation", "status"],
    key: "status",
    render: (value) => {
      return (
        <Tag
          className="flex items-center justify-center"
          color={
            value === "Accepted"
              ? "success"
              : value === "Pending"
              ? "warning"
              : "error"
          }
        >
          {Capitalize(value)}
        </Tag>
      );
    },
  },
  {
    title: "Created On",
    dataIndex: ["quotation", "created_at"],
    key: "created_at",
    render: (value) => {
      const date = new Date(value).toDateString();
      return date;
    },
  },
];
export default QuotationPage;
